export const RESIZE_THROTTLE_MS = 500;
